<div class="layout-container">
  <div class="sidebar"
  *ngIf="!isSpecialRoute"
  [class.mobileCollapsed]="collapsed"
  ><app-sidebar

    [collapsed]="collapsed"
    (collapsedChange)="toggleCollapse($event)"

    /></div>
  <div class="main-app-content">
    <div class="header" *ngIf="!isSpecialRoute">
     <app-header
     [collapsed]="collapsed"
     (collapsedChange)="toggleCollapse($event)"/>
    </div>
    <div class="content"><router-outlet /></div>
  </div>
</div>
